import { render, staticRenderFns } from "./egon-muller.vue?vue&type=template&id=0b88f21b&scoped=true"
import script from "./egon-muller.vue?vue&type=script&lang=js"
export * from "./egon-muller.vue?vue&type=script&lang=js"
import style0 from "./egon-muller.vue?vue&type=style&index=0&id=0b88f21b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b88f21b",
  null
  
)

export default component.exports